import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth } from '../../../../constants/actions'
import withRecaptcha from '../../../../hoc/withRecaptcha'
import SignupGuest from './component'

export const mapStateToProps = state => ({
  eventLogo: get(state, 'formSettings.eventLogo'),
  signUpGuestMsg: get(state, 'auth.signUpGuestMsg.message'),
  isSubmitPending: get(state, 'common.showLoadingIndicator'),
  formType: get(state, 'formSettings.formType'),
})

export default connect(mapStateToProps, {
  signUpGuest: auth.signUpGuest,
  setSignupGuestMsg: auth.setSignupGuestMsg,
  verifyEmail: auth.verifyEmail,
  resetForm: auth.signout,
})(withRecaptcha('SignupGuest')(SignupGuest))
